export const ACTION_DETACH_GOOGLE__REQUEST = 'ACTION_DETACH_GOOGLE__REQUEST';
export const ACTION_DETACH_GOOGLE__SUCCESS = 'ACTION_DETACH_GOOGLE__SUCCESS';
export const ACTION_DETACH_GOOGLE__FAIL = 'ACTION_DETACH_GOOGLE__FAIL';

export const ACTION_DETACH_TWITTER__REQUEST = 'ACTION_DETACH_TWITTER__REQUEST';
export const ACTION_DETACH_TWITTER__SUCCESS = 'ACTION_DETACH_TWITTER__SUCCESS';
export const ACTION_DETACH_TWITTER__FAIL = 'ACTION_DETACH_TWITTER__FAIL';

export const ACTION_LOAD_SOCIAL_NETWORKS__REQUEST = 'ACTION_LOAD_SOCIAL_NETWORKS__REQUEST';
export const ACTION_LOAD_SOCIAL_NETWORKS__SUCCESS = 'ACTION_LOAD_SOCIAL_NETWORKS__SUCCESS';
export const ACTION_LOAD_SOCIAL_NETWORKS__FAIL = 'ACTION_LOAD_SOCIAL_NETWORKS__FAIL';
